import { useEffect, useRef, useState } from "react";
import CardCarousel from "../../../components/CardCarousel/CardCarousel";
import HeadPage from "../../../components/HeadPage/HeadPage";
import ImageCarousel from "../../../components/ImageCarousel/ImageCarousel";
import WrapperDetail from "../../../components/WrapperDetail/WrapperDetail";
import { fetchData } from "../../../fetcher";
import TheMallOutletLayout from "../../../layouts/TheMallOutletLayout/TheMallOutletLayout";
import styles from "../../../styles/pages/specific-brand.module.scss";
import ScrollDown from "../../../components/ScrollDown/ScrollDown";
import BookingForm from "../../../components/BookingForm/BookingForm";
import axios from 'axios';
import { useRouter } from "next/router";
import Map from "../../../components/Map/Map";



const BrandDetailPage = ({ menuItems, dataContent, properties }) => {
  const [bookableBrand, setBookableBrand] = useState();
  const [disableDate, setDisableDate] = useState([]);
  const [brandId, setBrandId] = useState();
  const [bookingDays, setBookingDays] = useState();
  const [apptoken, setAppToken] = useState();
  const [lang, setLang] = useState();
  const [slotLen, setSlotLen] = useState();
  const [bookEnabled, setBookEnabled] = useState();
  const scrollToRef = useRef(null);
  const router = useRouter();

  const [app, setApp] = useState(false);

  useEffect(() => {
    const lang = window.location.pathname.split('/')[1];
    setLang(lang)
  }, [])
  const brandname = dataContent.head.title.toLowerCase().trim().replace(' ', '_');
  const bookableBrandNames = bookableBrand && bookableBrand.map((b) => b.name.toLowerCase().trim().replace(' ', '_'))
  //SL
  const isBookable = bookableBrandNames && bookableBrandNames.includes(brandname)
  //const isBookable = false

  const today = new Date();
  const gg = today.getDate();
  const mm = today.getMonth() + 1;
  const aaaa = today.getFullYear();
  const dateFrom = `${aaaa}-${mm - 1}-${gg}`;
  const dateTo = `${aaaa}-${mm + 12}-${gg}`;
  const { map } = dataContent

  useEffect(() => {
    if (router.asPath.includes("?app=true")) {
      setApp(true);
      if (router.asPath.includes('&at=')) {
        const token = router.asPath.split('&at=')[1];
        setAppToken(token);
      } else {
        router.push('/error')
      }
    }
  }, []);


  useEffect(() => {
    fetchDataBrands();
  }, []);

  const fetchDataBrands = async () => {
    let isMounted = true;

    try {
      const brandsRes = await axios({
        method: 'GET',
        url: `${process.env.NEXT_PUBLIC_FE_SERVICES}`,
      })
      if (isMounted) {
        setBookableBrand(brandsRes.data.services);
        brandsRes.data.services && brandsRes.data.services.map((b) => {
          if (b.name.toLowerCase().trim().replace(' ', '_') === brandname) {
            setBrandId(b.id)
            setSlotLen(b.slot_len)
            setBookEnabled(b.enabled)
          }
        })
      }


    } catch (error) {
      console.error('Error loading map: ' + error);
    }
    return () => {
      isMounted = false;
    }
  }

  useEffect(() => {
    if (brandId) {
      const fetchDataTime = async () => {
        try {
          const bookingDays = await axios({
            url: `${process.env.NEXT_PUBLIC_FE_CALENDAR}/${brandId}/calendar?date_from=${dateFrom}&date_to=${dateTo}`,
            method: "GET",
          }
          )
          let disable = [];
          bookingDays.data.calendar && bookingDays.data.calendar.map((day) => {
            if (day.day_closed === '1') {
              disable.push(day.date);
            }
          })
          setBookingDays(bookingDays.data.calendar)
          setDisableDate(disable)
        }
        catch (error) {
          console.error('Error loading map: ' + error);
        }
        return () => {
          isMounted = false;
        }
      }
      fetchDataTime();
    }

  }, [brandId])


  return (
    <TheMallOutletLayout menuItems={menuItems} app={app}>
      {!app && <>
        <div id="head" ref={scrollToRef}>
          <HeadPage {...dataContent?.head} />
        </div>
        <div className={`centeredSection ${styles.WrapperDetail}`}>
          <WrapperDetail {...dataContent?.brand.card} />
        </div>
      </>
      }
      {isBookable && bookEnabled === '1' &&
        <BookingForm
          brandName={dataContent.head.title}
          dataContent={dataContent.booking}
          properties={properties}
          bookingDays={bookingDays}
          disableDate={disableDate}
          bookableBrand={bookableBrand}
          slotLen={slotLen}
          lang={lang}
          brandId={brandId}
          app={app}
          apptoken={apptoken}
        />
      }
      {!app && map &&
        (
          <div className={styles.fakeMap}>
            <Map title={dataContent.map.title} url={dataContent.map.url} />
          </div>
        )
      }
      {!app && dataContent?.carousel && dataContent?.carousel.items.length > 0 && (
        <div className={styles.ImageCarousel}>
          <ImageCarousel
            items={dataContent.carousel.items}
            title={dataContent.carousel.title}
            smallImg
          />
        </div>
      )}
      {!app && dataContent.brandCarousel.items &&
        dataContent.brandCarousel.items.length > 0 && (
          <div className={styles.CardCarousel}>
            <CardCarousel
              listOfBrands={dataContent.brandCarousel.items}
              goldTitle={dataContent.brandCarousel.goldTitle}
              more={dataContent.brandCarousel.more}
              hoverText={dataContent.brandCarousel.hoverText}
            />
          </div>
        )}
      {scrollToRef && (
        <div className="scroll">
          <ScrollDown selector={scrollToRef} scrollTop />
        </div>
      )}
    </TheMallOutletLayout>
  );
};

BrandDetailPage.getInitialProps = async (context) => {
  let menuItems = null;
  let dataContent = null;
  let properties = null;
  const { slug } = context.query;

  const resmenu = await fetchData("/init", context.query.locale);
  const data = await fetchData(slug, context.query.locale);
  const resproperties = await fetchData(null, context.query.locale, 'GET', null, null, null, true);


  if (resmenu) {
    menuItems = resmenu.menu;
  }

  if (data) {
    dataContent = data;
  }
  if (resproperties) {
    properties = resproperties
  }


  return {
    menuItems: menuItems,
    dataContent: dataContent,
    properties: properties
  };
};

export default BrandDetailPage;
